// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__KMTvB","dot":"pagination_dot__MOax0","active":"pagination_active__a_Qp_"};